import { useState, useEffect, useRef, useCallback } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';

// Sons de notificação em base64 (simples beeps gerados)
const SONS = {
  notification1: 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdH2Onp+ZjHdwaG15hp6vsLCliXVoZW95j6S2ubiqlH1uaW17kKjAy8i2nYRybW+Ck6/I1dPBpot4cHSIm7fO3NnHq5F+dHqRqcHW5OTUvqSOfXuOnrnR5O/s2sGnkYGElafE2+v28+PWvqOQiI6kt9Xp+Pv36tazoJOTpbzW6/3//+7byquclqW50uj7///16NOwop6osM7j+P//+uzXt6eioq+8z+P3///87NzAraajrrjK3fL+//7x4Ma0q6WqtL/P4fP9//zw4Mi4rqiqsrnH2Oz6/v3x4sy8s6yrs7nE1Of3/fz08NvHvLewtbnBzNvo9/v6+O/eyL+7t7W5v8jU4/H4+vjy5NLIw7+8u77Dytfk7/b4+Pfv5tXNx8PBwMHEx87Y4+zz9vf38OrkzcfDwsLDxsnP2OHr8fT19vDr5M7IxMPDxMbJztbf5+7z8/T27+vmzsrGxMTFx8rO09rh6O7x8vPz8O3n1M7KxsbGx8nM0NXb4Ofq7e/w8PHv6+TazsvIx8fIyczP09ja3+Pm6evs7e7u7Org2c7KycjIyMnLzdDS1dja3eHj5efp6uvs7Ovi2dHMysnJycnKy83P0tTW2dze4OLk5ufo6erg2NDMysnJycnJysvNz9HT1djb3d/h4+Xm5+jo6OHZz8zKycnJycnJysvNz9HT1djb3d/h4+Xm5+jo5+DXzsrJyMjIyMjJysvNz9HS1NfZ293f4ePl5ufo6eff1szJyMjIyMjIycnLzc/R0tTX2dve4OLk5ufo5+TdzsrIx8fHx8fHyMnLzc/R0tTX2dve4OPl5+jp59/UycfGxsbGxsbGx8jKzM7Q0tXY2t3f4uTm5+jp5tzNxcTDw8PDw8PExcfJy87Q09bZ3N/i5Ofp6ujh1MfDwsHBwcHBwcLDxcfJzM/R1Njb3+Ll6Onq6OHUxcLAwMDAwMDAwMHDxcjLztHU19rf4uXo6uro39LDv76+vr6+vr6/wMPGyczP0tbZ3eDj5unq6uff0MK+vb29vb29vb6/wcTHys3Q1Nfa3uHk5+rq6eXdzsC9vLy8vLy8vL2+wMPGys3R1Nfa3uHl6Orr6eXczcC9u7u7u7u7u7y9v8LFyMzP09fa3uHl5+rr6eXczcC9u7u7u7u7u7y9v8LFyMzP09fa3eHl5+rq6eXczcC9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+rq6eXczcC9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+rq6eXczb+9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+np6OTczb+9u7u7u7u7u7y9v8LFyMvP0tfZ3eHk5+np6OTbzL+9u7u7u7u7u7y9v8LFyMvP0tfZ3eDk5+np6OTbzL+9u7u7u7u7u7y9vsHFyMvO0tbZ3eDk5unp6OPbzL+9u7u7u7u7u7y9vsHFyMvO0tbZ3eDk5unp5+PazL+9u7u7',
  notification2: 'data:audio/wav;base64,UklGRl9EAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YTtEAACA/3//f/9//3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA/3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA/3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA',
  notification3: 'data:audio/wav;base64,UklGRqQFAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YYAFAACAgICAgICAgIB/f39/f39/gICAgICAgICAgH9/f39/f3+AgICAgICAgICAf39/f39/f4CAgICAgICAgIB/f39/f39/gICAgICAgICAgH9/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAgH9/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAf39/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAf39/f39/f3+AgICAgICAgH9/f39/f39/',
  beep: 'data:audio/wav;base64,UklGRl9EAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YTtEAAD/f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//fwCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACA',
  chime: 'data:audio/wav;base64,UklGRpYEAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YXIEAACAf4B/gH+Af4B/gICAf4CAgICAgICAgYGBgYGBgYGCgoKCgoKCgoODg4ODg4ODhISEhISEhISFhYWFhYWFhoaGhoaGhoaHh4eHh4eHiIiIiIiIiImJiYmJiYmKioqKioqKi4uLi4uLi4yMjIyMjIyNjY2NjY2Njo6Ojo6OjpCQkJCQkJCRkZGRkZGRk5OTk5OTk5WVlZWVlZWXl5eXl5eXmZmZmZmZmZubm5ubm5udnZ2dnZ2dn5+fn5+fn6GhoaGhoaGjo6Ojo6Ojo6WlpaWlpaWnp6enp6enqampqampqaurq6urq6utra2tra2tr6+vr6+vr7GxsbGxsbGzs7Ozs7Ozs7W1tbW1tbW3t7e3t7e3ubm5ubm5ubu7u7u7u7u9vb29vb29v7+/v7+/v8HBwcHBwcHDw8PDw8PDxcXFxcXFxcfHx8fHx8fJycnJycnJy8vLy8vLy83Nzc3Nzc3Pz8/Pz8/P0dHR0dHR0dPT09PT09PV1dXV1dXV19fX19fX19nZ2dnZ2dna2tra2tra3Nzc3Nzc3N7e3t7e3t7g4ODg4ODg4uLi4uLi4uTk5OTk5OTm5ubm5ubm6Ojo6Ojo6Orq6urq6urr6+vr6+vr7e3t7e3t7e/v7+/v7+/x8fHx8fHx8/Pz8/Pz8/X19fX19fX39/f39/f3+fn5+fn5+fv7+/v7+/v9/f39/f39//////////////////////////////////8='
};

// Lista de sons que usam Web Audio API
const SONS_WEB_AUDIO = ['modern1', 'modern2', 'modern3', 'urgent1', 'urgent2', 'whatsapp', 'messenger', 'telegram'];

// Função para gerar sons usando Web Audio API (mais modernos e altos)
function gerarSomWebAudio(tipo, volume = 1) {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const gainNode = audioContext.createGain();
    gainNode.connect(audioContext.destination);
    gainNode.gain.value = volume * 1.5; // Volume mais alto
    
    const now = audioContext.currentTime;
    
    switch(tipo) {
      case 'modern1': // Pop moderno
        [880, 1100, 1320].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.1);
          osc.stop(now + i * 0.1 + 0.15);
        });
        break;
        
      case 'modern2': // Ding duplo
        [1200, 1600].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.15);
          osc.stop(now + i * 0.15 + 0.2);
        });
        break;
        
      case 'modern3': // Bubble
        const osc1 = audioContext.createOscillator();
        osc1.type = 'sine';
        osc1.frequency.setValueAtTime(400, now);
        osc1.frequency.exponentialRampToValueAtTime(1200, now + 0.2);
        osc1.connect(gainNode);
        osc1.start(now);
        osc1.stop(now + 0.25);
        break;
        
      case 'urgent1': // Alarme urgente
        [800, 1000, 800, 1000].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'square';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.12);
          osc.stop(now + i * 0.12 + 0.1);
        });
        break;
        
      case 'urgent2': // Sirene curta
        const oscSirene = audioContext.createOscillator();
        oscSirene.type = 'sawtooth';
        oscSirene.frequency.setValueAtTime(600, now);
        oscSirene.frequency.linearRampToValueAtTime(1200, now + 0.3);
        oscSirene.frequency.linearRampToValueAtTime(600, now + 0.6);
        oscSirene.connect(gainNode);
        oscSirene.start(now);
        oscSirene.stop(now + 0.6);
        break;
        
      case 'whatsapp': // Estilo WhatsApp
        [1046.5, 1318.5].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          const env = audioContext.createGain();
          env.gain.setValueAtTime(0, now + i * 0.08);
          env.gain.linearRampToValueAtTime(volume * 1.5, now + i * 0.08 + 0.02);
          env.gain.exponentialRampToValueAtTime(0.01, now + i * 0.08 + 0.15);
          osc.connect(env);
          env.connect(audioContext.destination);
          osc.start(now + i * 0.08);
          osc.stop(now + i * 0.08 + 0.15);
        });
        break;
        
      case 'messenger': // Estilo Messenger
        const oscMsg = audioContext.createOscillator();
        oscMsg.type = 'sine';
        oscMsg.frequency.setValueAtTime(987.77, now);
        oscMsg.frequency.setValueAtTime(1318.5, now + 0.1);
        oscMsg.connect(gainNode);
        oscMsg.start(now);
        oscMsg.stop(now + 0.2);
        break;
        
      case 'telegram': // Estilo Telegram
        [523.25, 659.25, 783.99].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'triangle';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.07);
          osc.stop(now + i * 0.07 + 0.12);
        });
        break;
        
      default:
        return false;
    }
    return true;
  } catch(e) {
    console.log('Erro Web Audio:', e);
    return false;
  }
}

export default function NotificacaoSom() {
  const [config, setConfig] = useState({
    ativo: true,
    som_tipo: 'notification1',
    volume: 0.7,
    tocar_em_todas_paginas: true,
    intervalo_verificacao: 5
  });
  const [ultimaVerificacao, setUltimaVerificacao] = useState(null);
  const audioRef = useRef(null);
  const intervalRef = useRef(null);

  // Carregar configuração de som
  const loadConfig = useCallback(() => {
    axios.get(API + '/config/som', { headers: getAuthHeader() })
      .then(res => {
        if (res.data) {
          setConfig(res.data);
        }
      })
      .catch(() => {});
  }, []);

  // Tocar som
  const tocarSom = useCallback(() => {
    if (!config.ativo) return;
    
    try {
      // Verificar se é um som Web Audio
      if (SONS_WEB_AUDIO.includes(config.som_tipo)) {
        if (gerarSomWebAudio(config.som_tipo, config.volume)) {
          return; // Som tocado com sucesso
        }
      }
      
      // Fallback para sons em base64
      const somSrc = SONS[config.som_tipo] || SONS.notification1;
      
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      
      audioRef.current = new Audio(somSrc);
      audioRef.current.volume = config.volume;
      audioRef.current.play().catch(() => {
        // Erro silencioso se o navegador bloquear
      });
    } catch (e) {
      console.log('Erro ao tocar som:', e);
    }
  }, [config.ativo, config.som_tipo, config.volume]);

  // Verificar novas mensagens
  const verificarNovasMensagens = useCallback(() => {
    if (!config.ativo || !config.tocar_em_todas_paginas) return;

    const params = ultimaVerificacao ? `?ultima_verificacao=${ultimaVerificacao}` : '';
    
    axios.get(API + '/atendimentos/novas-mensagens' + params, { headers: getAuthHeader() })
      .then(res => {
        if (res.data.tem_novas && res.data.ultimo_timestamp) {
          // Só toca som se a timestamp é realmente nova
          if (!ultimaVerificacao || res.data.ultimo_timestamp > ultimaVerificacao) {
            tocarSom();
          }
          setUltimaVerificacao(res.data.ultimo_timestamp);
        }
      })
      .catch(() => {});
  }, [config.ativo, config.tocar_em_todas_paginas, ultimaVerificacao, tocarSom]);

  // Inicializar
  useEffect(() => {
    loadConfig();
    
    // Setar timestamp inicial
    const agora = new Date().toISOString();
    setUltimaVerificacao(agora);
    
    // Recarregar config a cada 30 segundos para pegar mudanças
    const configInterval = setInterval(loadConfig, 30000);
    
    // Escutar evento de atualização de config (disparado pela página de config)
    const handleConfigUpdate = () => {
      loadConfig();
    };
    window.addEventListener('som-config-updated', handleConfigUpdate);
    
    return () => {
      clearInterval(configInterval);
      window.removeEventListener('som-config-updated', handleConfigUpdate);
    };
  }, [loadConfig]);

  // Polling para verificar novas mensagens
  useEffect(() => {
    if (config.ativo && config.tocar_em_todas_paginas) {
      // Limpar interval anterior
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      
      // Criar novo interval
      intervalRef.current = setInterval(verificarNovasMensagens, config.intervalo_verificacao * 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [config.ativo, config.tocar_em_todas_paginas, config.intervalo_verificacao, verificarNovasMensagens]);

  // Este componente não renderiza nada visível
  return null;
}

// Exportar função para tocar som manualmente (para usar em outros componentes)
export function tocarSomNotificacao(tipo = 'notification1', volume = 0.7) {
  try {
    // Verificar se é um som Web Audio
    if (SONS_WEB_AUDIO.includes(tipo)) {
      if (gerarSomWebAudio(tipo, volume)) {
        return;
      }
    }
    
    // Fallback para sons em base64
    const somSrc = SONS[tipo] || SONS.notification1;
    const audio = new Audio(somSrc);
    audio.volume = volume;
    audio.play().catch(() => {});
  } catch (e) {
    console.log('Erro ao tocar som:', e);
  }
}
